import * as React from 'react';

import {Dialog} from '../../dialog/dialog';

import {IconButton} from './icon-button';

type Props = {
    onConfirm: () => void;
    question: string;
    icon: React.ComponentType<any>;
    primaryText?: string;
    secondaryText?: string;
    buttonVariant?: 'primary' | 'danger';
    iconSize?: number;
    disabled?: boolean;
    dialogWidth?: string;
    isSmall?: boolean;
    tooltipText?: string;
    noHoverBackground?: boolean;
    noPadding?: boolean;
    iconHoverWhenConfirming?: boolean;
};

export function IconButtonWithConfirmation(props: Props) {
    const {
        icon,
        onConfirm,
        question,
        primaryText = 'Yes, remove',
        secondaryText = 'No, don’t remove',
        buttonVariant = 'danger',
        iconSize,
        disabled = false,
        dialogWidth,
        isSmall,
        tooltipText,
        noHoverBackground,
        noPadding,
        iconHoverWhenConfirming,
    } = props;

    const [isConfirmingRemove, setIsConfirmingRemove] = React.useState<boolean>(false);

    const removeRef = React.useRef<HTMLButtonElement | null | undefined>(null);

    return (
        <>
            <IconButton
                getButtonRef={removeRef}
                onClick={() => setIsConfirmingRemove(true)}
                variant={buttonVariant}
                size={iconSize}
                // @ts-expect-error
                disabled={disabled}
                icon={icon}
                isSmall={isSmall}
                tooltipText={tooltipText}
                noHoverBackground={noHoverBackground}
                noPadding={noPadding}
                forceHover={iconHoverWhenConfirming && isConfirmingRemove}
            />
            {isConfirmingRemove && (
                <Dialog
                    anchor={removeRef.current}
                    location='top'
                    question={question}
                    primaryText={primaryText}
                    secondaryText={secondaryText}
                    onPrimary={() => {
                        onConfirm();
                        setIsConfirmingRemove(false);
                    }}
                    onSecondary={() => {
                        setIsConfirmingRemove(false);
                    }}
                    isWarning={true}
                    customStyles={dialogWidth ? {width: dialogWidth} : undefined}
                />
            )}
        </>
    );
}
